module.exports = __webpack_public_path__ + "img/PS.7fb44a73.svg";